module.exports = __webpack_public_path__ + "img/roa-logo-white.a1fe9bdf.svg";